// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__KYhL5","hide":"style_hide__ff1xR"};